import React from 'react';
import { Grid } from '@mui/material';
import { StatisticsRow } from '../../types/supplierStatistics';
import { Delta, money, number } from './StatisticsTable';
import MetricCard from './MetricCard';

export default function StatisticsSummary({ row }: { row?: StatisticsRow }) {
  const metrics = [
    {
      label: 'Omsättning vald period',
      value: money(row?.totalRevenue),
      change: row?.revenueChange,
    },
    {
      label: 'Omsättning föregående år',
      value: row?.hasComparisonObservations ? money(row.previousRevenue) : '—',
      previous: true,
    },
    {
      label: 'Antal¹ vald period',
      value: number(row?.totalUnitsSold),
      change: row?.unitsChange,
      units: true,
    },
    {
      label: 'Antal¹ föregående år',
      value: row?.hasComparisonObservations
        ? number(row.previousUnitsSold)
        : '—',
      previous: true,
    },
  ];
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {metrics.map((metric) => (
        <Grid item xs={12} sm={6} lg={3} key={metric.label}>
          <MetricCard
            label={metric.label}
            value={metric.value}
            color="#2563eb"
            helper={
              metric.previous ? (
                row?.hasComparisonObservations ? (
                  'Samma datum · preliminärt'
                ) : (
                  'Ingen observerad historik'
                )
              ) : row?.hasComparisonObservations ? (
                <Delta value={metric.change} units={metric.units} />
              ) : (
                'Jämförelseunderlag saknas'
              )
            }
          />
        </Grid>
      ))}
    </Grid>
  );
}
